import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=0efcf55a&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=0efcf55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efcf55a",
  null
  
)

export default component.exports